import { useState, useEffect, FC } from 'react';
import { Input } from '@getsynapse/design-system';
import { EditableTableRowCell } from './EditableTableRowCell';
import { BaseCellProps } from './types';
import TruncatedTableColumn from 'Pages/ProjectsListPage/components/ActiveProjects/components/TruncatedTableColumn/TruncatedTableColumn';

interface TextTableRowCellProps extends BaseCellProps {
  value: string;
  placeholder?: string;
  maxLength?: number;
  type?: string;
}

export const TextTableRowCell: FC<TextTableRowCellProps> = ({
  value,
  isEditable,
  className = '',
  placeholder = 'Enter text',
  maxLength,
  type = 'text',
  onSave,
  onCancel,
}) => {
  const [editValue, setEditValue] = useState(value);

  useEffect(() => {
    setEditValue(value);
  }, [value]);

  const handleSave = () => {
    onSave?.(editValue);
  };

  const handleCancel = () => {
    setEditValue(value);
    onCancel?.();
  };

  const readModeChildren = (
    <TruncatedTableColumn
      content={<span>{value || placeholder}</span>}
      className={className}
    />
  );

  const editModeChildren = (
    <div className='w-full'>
      <Input
        value={editValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setEditValue(e.target.value)
        }
        placeholder={placeholder}
        maxLength={maxLength}
        type={type}
        className='w-full'
        autoFocus
      />
    </div>
  );

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <EditableTableRowCell
        isEditable={!!isEditable}
        editModeChildren={editModeChildren}
        readModeChildren={readModeChildren}
        className={className}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </div>
  );
};
